import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Edit2, Trash2, Phone, Mail, MapPin, FileText, BarChart3 } from 'lucide-react';
import { SUPPLIER_TYPES } from './SupplierFormFields';

const TYPE_COLORS = {
  fuel:      'bg-blue-100 text-blue-700',
  parts:     'bg-orange-100 text-orange-700',
  service:   'bg-green-100 text-green-700',
  tyres:     'bg-purple-100 text-purple-700',
  insurance: 'bg-red-100 text-red-700',
  general:   'bg-gray-100 text-gray-700',
};

const SupplierCard = ({ supplier, canEdit, canDelete, onEdit, onDelete, onReport }) => {
  const typeLabel = SUPPLIER_TYPES.find(t => t.value === supplier.supplier_type)?.label
    || supplier.supplier_type;
  const typeColor = TYPE_COLORS[supplier.supplier_type] || TYPE_COLORS.general;

  return (
    <Card className="card-hover">
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between">
          <div>
            <CardTitle className="text-lg font-semibold">{supplier.name}</CardTitle>
            <Badge className={`mt-1 ${typeColor}`}>{typeLabel}</Badge>
          </div>
          <div className="flex gap-1">
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={() => onReport(supplier)}
              title="View Report"
              data-testid={`supplier-report-${supplier.id}`}
            >
              <BarChart3 className="w-4 h-4 text-slate-400" />
            </Button>
            {canEdit && (
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                onClick={() => onEdit(supplier)}
                data-testid={`supplier-edit-${supplier.id}`}
              >
                <Edit2 className="w-4 h-4 text-slate-400" />
              </Button>
            )}
            {canDelete && (
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                onClick={() => onDelete(supplier)}
                data-testid={`supplier-delete-${supplier.id}`}
              >
                <Trash2 className="w-4 h-4 text-red-400" />
              </Button>
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        {supplier.contact_person && (
          <div className="flex items-center gap-2 text-slate-600">
            <span className="font-medium">{supplier.contact_person}</span>
          </div>
        )}
        {supplier.phone && (
          <div className="flex items-center gap-2 text-slate-500">
            <Phone className="w-4 h-4" />
            <span>{supplier.phone}</span>
          </div>
        )}
        {supplier.email && (
          <div className="flex items-center gap-2 text-slate-500">
            <Mail className="w-4 h-4" />
            <span>{supplier.email}</span>
          </div>
        )}
        {supplier.address && (
          <div className="flex items-center gap-2 text-slate-500">
            <MapPin className="w-4 h-4" />
            <span className="truncate">{supplier.address}</span>
          </div>
        )}
        {supplier.account_number && (
          <div className="flex items-center gap-2 text-slate-500">
            <FileText className="w-4 h-4" />
            <span className="font-data">Acc: {supplier.account_number}</span>
          </div>
        )}
        {supplier.payment_terms && (
          <div className="text-slate-400 text-xs">
            Payment: {supplier.payment_terms}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SupplierCard;
